export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'competition-rules',
    name: '比赛规则',
    description: '了解每日大赛Yandex的详细参赛规则、评分标准及注意事项，确保顺利参赛',
    icon: 'ri-book-open-line',
  },
  {
    slug: 'registration-guide',
    name: '报名指南',
    description: '手把手教你完成每日大赛Yandex官网注册和报名流程，快速开启竞技之旅',
    icon: 'ri-user-add-line',
  },
  {
    slug: 'reward-info',
    name: '奖励说明',
    description: '查看每日大赛Yandex丰厚奖励详情，包括现金奖励、积分兑换和荣誉勋章',
    icon: 'ri-trophy-line',
  },
  {
    slug: 'event-news',
    name: '赛事动态',
    description: '获取每日大赛Yandex最新赛事资讯、活动公告和平台更新信息',
    icon: 'ri-newspaper-line',
  },
  {
    slug: 'beginner-guide',
    name: '新手攻略',
    description: '新手玩家的入门秘籍，从零开始掌握Yandex每日大赛核心技巧与策略',
    icon: 'ri-rocket-line',
  },
];